export interface FrontConfig {
  restApiUrl: string,
  graphQlUrl: string,
  debug: boolean,
  oauth: {
    authServerUrl: string
    realm: string
    clientId: string
    idpHint: string
    init: {
      onLoad: string
      flow: string
      checkLoginIframe: boolean
      silentCheckSsoRedirectUri: string
      enableLogging: boolean
    }
  }
}

export interface ConfigInstances<T extends FrontConfig> {
  development: T
  staging: T,
  production: T

}

export const ConfigInstance: ConfigInstances<FrontConfig> = {
  staging: {
    graphQlUrl: "https://app.pickfoot.com/api/graphql",
    restApiUrl: "https://app.pickfoot.com/api",
    debug: true,
    oauth: {
      authServerUrl: 'https://auth.staging.betrue.fr/auth/',
      realm: 'staging',
      clientId: 'store-locator',
      idpHint: 'staging',
      init: {
        onLoad: 'check-sso',
        flow: 'implicit',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        enableLogging: true
      }
    }
  },
  development: {
    graphQlUrl: "http://localhost:3333/graphql",
    restApiUrl: "http://localhost:3333",
    debug: true,
    oauth: {
      authServerUrl: 'https://auth.staging.betrue.fr/auth/',
      realm: 'staging',
      clientId: 'store-locator',
      idpHint: 'dev',
      init: {
        onLoad: 'check-sso',
        flow: 'implicit',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        enableLogging: true
      }
    }
  },
  production: {
    graphQlUrl: "http://localhost:3333/graphql",
    restApiUrl: "http://localhost:3333",
    debug: true,
    oauth: {
      authServerUrl: 'https://auth.staging.betrue.fr/auth/',
      realm: 'staging',
      clientId: 'store-locator',
      idpHint: 'prod',
      init: {
        onLoad: 'check-sso',
        flow: 'implicit',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: window.location.origin + '/wp-content/plugins/store-locator/dist/assets/silent-check-sso.html',
        enableLogging: true
      }
    }
  },

}
declare global {
  interface Window {
    FRONT_CONFIG: FrontConfig
  }
}

const env = process.env['NODE' + '_ENV'] ? process.env['NODE' + '_ENV'] : 'development'


window.FRONT_CONFIG = ConfigInstance[env] || ConfigInstance.development

